:host {
    display: block;
}

.joy-avatars-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: var(--joy-core-spacing-3) var(--joy-core-spacing-6);

    &.joy-avatars-list__compress {
        gap: 0;
    }
}